import { Form } from 'reactstrap';

export const PersonFormRoot = ({
  onSubmit,
  children,
}: React.PropsWithChildren<{ onSubmit: () => void }>) => (
  <Form
    autoComplete="off"
    onSubmit={(e) => {
      e.preventDefault();
      onSubmit();
      return false;
    }}
  >
    {children}
  </Form>
);
